export default "__VITE_ASSET__55462522__"